"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InStockSign = void 0;
var react_1 = __importDefault(require("react"));
var InStockSign_module_scss_1 = __importDefault(require("./InStockSign.module.scss"));
var InStockSign = function (_a) {
    var extraClassName = _a.extraClassName, state = _a.state;
    return (react_1.default.createElement("div", { className: "".concat(InStockSign_module_scss_1.default.in_stock_sign, " ").concat(extraClassName || '') }, state ? 'В наличии' : 'Нет в наличии'));
};
exports.InStockSign = InStockSign;
